import {createContext} from "react"
export const EcpWorkflowContext = createContext({
    ecpWorkflowContext: null,
    setEcpWorkflowAction: () => {},
})